import { trackPromise } from 'react-promise-tracker';

/**
 * Fetcher class to call routes async specified in the Controllers in the ServiceProvider folder.
 * Uses node module react-promise-tracker to enable the LoadingSpinner while fetching data.
 * The Fetch methods are not specified by comments, since the props are mostly the same.
 * "openAlert" is used for showing an alert message in the calling component if the fetch failed
 * "handleCloseModal" closes a mask modal if the creation was valid, else it stays open for editing
 * the first prop most of the time is either an id or an object to create
 * 
 * If a function calls another with an added "Tracked" term, the trackPromise hook for initializing the LoadingSpinner is called.
 */

///ArticleTypes
const FetchCreateArticleType = async (articleTypeToCreate, handleCloseModal, openAlert) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    const createArticleType = 'faex/articleTypes/createArticleTypes/{' + sessionSysId + '}/{' + ownerSysId + '}'
    try {
        let response = await fetch(createArticleType, {
            method: "POST",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(articleTypeToCreate),
        })
        if (response.ok) {
            handleCloseModal()
            return await response.json()
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}

const FetchUpdateArticleType = async (articleTypeToUpdate, handleCloseArticle, openAlert) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    const updateArticleType = 'faex/articleTypes/updateArticleTypes/{' + sessionSysId + '}/{' + ownerSysId + '}'
    try {
        let response = await fetch(updateArticleType, {
            method: "PUT",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(articleTypeToUpdate),
        })
        if (response.ok) {
            handleCloseArticle()
            return await response.json()
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}

const FetchArticleTypesTracked = async (setArticleData, openAlert, setArticleDataToReady) => {
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    const getArticleTypes = 'faex/articleTypes/getArticleTypes/{' + sessionSysId + '}/{' + ownerSysId + '}'

    try {
        let response = await fetch(getArticleTypes)
        if (response.ok) {
            let json = await response.json()
            await setArticleData(JSON.parse(json))
            setArticleDataToReady(true)
        } else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchArticleTypes = (setArticleData, openAlert, setArticleDataToReady) => {
    trackPromise(FetchArticleTypesTracked(setArticleData, openAlert, setArticleDataToReady))
}

const FetchArticleTypeImages = async (articleSysIds, addingImages, openAlert) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    const getArticleTypeImage = 'faex/articleTypes/getArticleTypeImages/{' + sessionSysId + '}'
    try {
        let response = await fetch(getArticleTypeImage, {
            method: "PUT",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(articleSysIds),
        })
        if (response.ok) {
            let json = await response.json()
            addingImages(JSON.parse(json))
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}

///Create Transactions
const FetchTransactionInfosTracked = async (setArticles, setSizeCats, openAlert, setArticleDataToReady) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    let isFaex = JSON.parse(sessionStorage.getItem("loginInformation")).StorageType === "FAEX"
    const getTransationInfos = 'faex/transactions/getInfosForTransaction/{' + sessionSysId + '}/{' + ownerSysId + '}/{' + isFaex + '}'

    try {
        let response = await fetch(getTransationInfos)
        if (response.ok) {
            let json = await response.json()
            await setArticles(JSON.parse(json))
            await setSizeCats([...new Set(JSON.parse(json).map(x => x.SizeCat))].sort())
            setArticleDataToReady(true)
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchTransactionInfos = (setArticles, setSizeCats, openAlert, setArticleDataToReady) => {
    trackPromise(FetchTransactionInfosTracked(setArticles, setSizeCats, openAlert, setArticleDataToReady))
}

const FetchCreateTransaction = async (transactionToCreate, handleClose, openAlert, reloadParent = null, resetOrderEntries = null) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    const createTransaction = 'faex/transactions/createTransaction/{' + sessionSysId + '}/{' + storageSysId + '}'
    try {
        let response = await fetch(createTransaction, {
            method: "POST",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(transactionToCreate),
        })
        if (response.ok) {
            handleClose()
            if (reloadParent !== null) reloadParent()
            if (resetOrderEntries !== null) resetOrderEntries()
            return await response.json()
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        //handleClose()
        openAlert()
    }
}

///Transaction Drafts
const FetchCreateTransactionDraft = async (draftToSave, handleClose, openAlert, reloadParent = null, resetOrderEntries = null) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    const createTransaction = 'faex/transactions/createTransactionDraft/{' + sessionSysId + '}/{' + storageSysId + '}'
    try {
        let response = await fetch(createTransaction, {
            method: "POST",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(draftToSave),
        })
        if (response.ok) {
            handleClose()
            if (reloadParent !== null) reloadParent()
            if (resetOrderEntries !== null) resetOrderEntries()
            return await response.json()
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}

const FetchUpdateTransactionDraft = async (draftToUpdate, draftSysId, handleClose, openAlert, reloadParent = null, resetOrderEntries = null) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    const createTransaction = 'faex/transactions/updateTransactionDraft/{' + sessionSysId + '}/{' + storageSysId + '}/{' + draftSysId + '}'
    try {
        let response = await fetch(createTransaction, {
            method: "PUT",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(draftToUpdate),
        })
        if (response.ok) {
            handleClose()
            if (reloadParent !== null) {
                reloadParent()
            }
            if (resetOrderEntries !== null) resetOrderEntries()
            return await response.json()
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}

const FetchDeleteTransactionDraft = async (draftToDelete, openAlert, reload) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    const deleteTransaction = 'faex/transactions/deleteTransactionDraft/{' + sessionSysId + '}/{' + storageSysId + '}/{' + draftToDelete + '}'
    try {
        let response = await fetch(deleteTransaction, {
            method: "DELETE",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
        })
        if (response.ok) {
            reload()
            return await response.json()
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}

///Transactions
const FetchReadIncomingTransactionsTracked = async (setIncomingTransactions, openAlert, setArticleDataToReady) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    const readTransactions = 'faex/transactions/getIncomingTransactions/{' + sessionSysId + '}/{' + ownerSysId + '}/{' + storageSysId + '}'
    try {
        let response = await fetch(readTransactions)
        if (response.ok) {
            let json = await response.json()
            await setIncomingTransactions(JSON.parse(json))
            setArticleDataToReady(true)
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchReadIncomingTransactions = (setIncomingTransactions, openAlert, setArticleDataToReady) => {
    trackPromise(FetchReadIncomingTransactionsTracked(setIncomingTransactions, openAlert, setArticleDataToReady))
}

const FetchReadOutgoingTransactionsTracked = async (setOutgoingTransactions, openAlert, setArticleDataToReady) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    let sourceStorageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    const readTransactions = 'faex/transactions/getOutgoingTransactions/{' + sessionSysId + '}/{' + ownerSysId + '}/{' + sourceStorageSysId + '}'
    try {
        let response = await fetch(readTransactions)
        if (response.ok) {
            let json = await response.json()
            console.log("setOutgoingTransactions ", json)
            await setOutgoingTransactions(JSON.parse(json))
            console.log("setOutgoingTransactions ", JSON.parse(json))
            setArticleDataToReady(true)
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchReadOutgoingTransactions = (setOutgoingTransactions, openAlert, setArticleDataToReady) => {
    trackPromise(FetchReadOutgoingTransactionsTracked(setOutgoingTransactions, openAlert, setArticleDataToReady))
}

const FetchApproveCorrection = async (stateChangeModel, handleCloseConfirmationModal, reload, openAlert) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    const approveCorrection = 'faex/transactions/approveCorrection/{' + sessionSysId + '}'
    try {
        let response = await fetch(approveCorrection, {
            method: "PUT",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(stateChangeModel),
        })
        if (response.ok) {
            handleCloseConfirmationModal()
            reload()
            return await response.json();
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}

///Inventory
const FetchInventoryTracked = async (setFetchStock, openAlert, setArticleDataToReady) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    let isFaex = JSON.parse(sessionStorage.getItem("loginInformation")).StorageType == 'FAEX'
    const getInventoryRoute = 'faex/stock/getArticleStockItems/{' + sessionSysId + '}/{' + ownerSysId + '}/{' + storageSysId + '}/{' + isFaex + '}'
    try {
        let response = await fetch(getInventoryRoute)
        if (response.ok) {
            let json = await response.json()
            await setFetchStock(JSON.parse(json))
            setArticleDataToReady(true)
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchInventory = (setFetchStock, openAlert, setArticleDataToReady) => {
    trackPromise(FetchInventoryTracked(setFetchStock, openAlert, setArticleDataToReady))
}

const FetchLocalizedAnalysisTracked = async (articleTypeSysId, size, setLocalizedAnalysis, openAlert) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    const route = 'faex/stock/getLocalizedAnalysis/{' + sessionSysId + '}/{' + ownerSysId + '}/{' + articleTypeSysId + '}'
    try {
        let response = await fetch(route, {
            method: "POST",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(size),
        })
        if (response.ok) {
            let json = await response.json()
            await setLocalizedAnalysis(JSON.parse(json))
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchLocalizedAnalysis = (articleTypeSysId, size, setLocalizedAnalysis, openAlert) => {
    trackPromise(FetchLocalizedAnalysisTracked(articleTypeSysId, size, setLocalizedAnalysis, openAlert))
}

///Login
const FetchLogin = (userHasAuthenticated, loginData, setError) => {
    const uri = 'login'
    trackPromise(
        fetch(uri, {
            method: "POST",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(loginData),
        })).then(function (response) {
            if (response.ok) {
                return response.json()
            }
            else {
                throw new Error(response.statusText)
            }
        }).then(function (json) {
            setError(false)
            sessionStorage.setItem("isAuthenticated", "true")
            sessionStorage.setItem("loginInformation", json)
            sessionStorage.setItem("username", loginData.username)
            sessionStorage.setItem("serverVersion", JSON.parse(json).ServerVersion)
            userHasAuthenticated(true)
        }).catch(function (err) {
            console.log('Fetch Login problem: ' + err.message)
            setError(true)
        });
}

const FetchChangePassword = (passwordChangeData, setError) => {
    const uri = 'login/changePassword'
    trackPromise(
        fetch(uri, {
            method: "POST",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(passwordChangeData),
        })).then(function (response) {
            if (response.ok) {
                return response.json()
            }
            else {
                throw new Error(response.statusText)
            }
        }).then(function (json) {
            setError(false)
        }).catch(function (err) {
            console.log('Fetch Login problem: ' + err.message)
            setError(true)
        });
}

const FetchGenders = (setGenders, openAlert) => {
    const genderUri = 'faex/articleTypes/getGenders'
    trackPromise(
        fetch(genderUri).then(function (response) {
            if (response.ok) {
                return response.json()
            }
            else {
                throw new Error(response.statusText)
            }
        }).then(function (json) {
            setGenders(JSON.parse(json))
        }).catch(function (err) {
            console.log('Fetch problem: ' + err.message)
            openAlert()
        }));
}

const FetchSizeCategoriesTracked = async (setSizeCategories, openAlert) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    const sizeCatUri = 'faex/articleTypes/getSizeCategories/{' + sessionSysId + '}'

    try {
        let response = await fetch(sizeCatUri)
        if (response.ok) {
            let json = await response.json()
            setSizeCategories(JSON.parse(json))
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchSizeCategories = (setSizeCategories, openAlert) => {
    trackPromise(FetchSizeCategoriesTracked(setSizeCategories, openAlert))
}

const FetchRegisterSalesReportTracked = async (setOptions, openAlert) => {
    let userSysId = JSON.parse(sessionStorage.getItem("loginInformation")).UserSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId

    const uri = 'faex/salesReport/registerSalesReport/{' + storageSysId + '}/{' + userSysId + '}'

    try {
        let response = await fetch(uri)
        if (response.ok) {
            let json = await response.json()
            setOptions(JSON.parse(json))
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchRegisterSalesReport = (setOptions, openAlert) => {
    trackPromise(FetchRegisterSalesReportTracked(setOptions, openAlert))
}

const FetchSalesReportDesignerTracked = async (setReport, options, openAlert) => {
    let userSysId = JSON.parse(sessionStorage.getItem("loginInformation")).UserSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId

    const uri = 'faex/salesReport/getSalesReportDesigner/{' + storageSysId + '}/{' + userSysId + '}'

    try {
        let response = await fetch(uri, {
            method: "PUT",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(options),
        })
        if (response.ok) {
            let json = await response.json()
            setReport(JSON.parse(json))
        }
        else {
            throw new Error(response.statusText)
        }
        //let response = await fetch(uri)
        //if (response.ok) {
        //    let json = await response.json()
        //    setReport(JSON.parse(json))
        //}
        //else {
        //    throw new Error(response.statusText)
        //}
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchSalesReportDesigner = (setReport, options, openAlert) => {
    trackPromise(FetchSalesReportDesignerTracked(setReport, options, openAlert))
}

const FetchB2COrderTransactionsDesignerTracked = async (setReport, options, openAlert) => {
    let userSysId = JSON.parse(sessionStorage.getItem("loginInformation")).UserSysId
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId

    const uri = 'faex/b2COrders/getB2COrdersDesigner/{' + ownerSysId + '}/{' + userSysId + '}/{' + sessionSysId + '}'

    try {
        console.log(uri)
        let response = await fetch(uri)
        if (response.ok) {
            let json = await response.json()
            console.log("FetchB2COrderTransactionsDesignerTracked", json, JSON.parse(json))
            setReport(prev => prev = JSON.parse(json))
        }
        else {
            throw new Error(response.statusText)
        }
        //let response = await fetch(uri)
        //if (response.ok) {
        //    let json = await response.json()
        //    setReport(JSON.parse(json))
        //}
        //else {
        //    throw new Error(response.statusText)
        //}
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchB2COrderTransactionsDesigner = (options, openAlert) => {
    trackPromise(FetchB2COrderTransactionsDesignerTracked(options, openAlert))
}

const FetchUpdateB2COrderTransactionsDesignerRemarkTracked = async (options, openAlert) => {
    let userSysId = JSON.parse(sessionStorage.getItem("loginInformation")).UserSysId
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId

    const uri = 'faex/b2COrders/updateB2COrdersDesignerRemark/{' + ownerSysId + '}/{' + userSysId + '}/{' + sessionSysId + '}'

    try {
        console.log(uri)
        let response = await fetch(uri, {
            method: "POST",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(options)
            })
            .then(function (response) {
                if (response.ok) {
                    return response.json()
                }
                else {
                    throw new Error(response.statusText)
                }
            }).then(function (json) {
            }).catch(function (err) {
                console.log('Fetch Login problem: ' + err.message)
            })
    }
    catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchUpdateB2COrderTransactionsDesignerRemark = (options, openAlert) => {
    trackPromise(FetchUpdateB2COrderTransactionsDesignerRemarkTracked(options, openAlert))
}

const FetchB2COrderStateTracked = async (setStates) => {

    const uri = 'faex/b2COrders/getB2COrderState/'

    try {
        console.log(uri)
        let response = await fetch(uri)
        if (response.ok) {
            let json = await response.json()
            console.log(uri, JSON.parse(json))
            setStates(JSON.parse(json))
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
    }
}
const FetchB2COrderState = (setStates) => {
    trackPromise(FetchB2COrderStateTracked(setStates))
}


const FetchB2COrderStateProcessingTracked = async (setStates) => {

    const uri = 'faex/b2COrders/getB2COrderProcessingState/'

    try {
        console.log(uri)
        let response = await fetch(uri)
        if (response.ok) {
            let json = await response.json()
            setStates(prev => prev = JSON.parse(json))
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
    }
}
const FetchB2COrderProcessingState = (setStates) => {
    trackPromise(FetchB2COrderStateProcessingTracked(setStates))
}

const FetchBackendPingToPreventTimeout = async () => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    const uri = 'faex/keepConnection/{' + sessionSysId + '}'

    try {
        let response = await fetch(uri)
        if (response.ok) {
            let json = await response.json()
            return json
        } else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
    }
}

const FetchReadServerVersion = async (setServerVersion) => {
    const uri = 'faex/getServerVersion/'

    try {
        let response = await fetch(uri)
        if (response.ok) {
            let json = await response.json()
            setServerVersion(JSON.parse(json))
            return json
        } else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
    }
}

export {
    FetchCreateArticleType, FetchArticleTypes, FetchUpdateArticleType,
    FetchTransactionInfos, FetchCreateTransaction,
    FetchReadIncomingTransactions, FetchReadOutgoingTransactions, FetchB2COrderTransactionsDesigner, FetchApproveCorrection, 
    FetchUpdateB2COrderTransactionsDesignerRemark,
    FetchInventory, FetchLocalizedAnalysis,
    FetchLogin,
    FetchGenders, FetchSizeCategories,
    FetchArticleTypeImages,
    FetchCreateTransactionDraft, FetchUpdateTransactionDraft, FetchDeleteTransactionDraft,
    FetchRegisterSalesReport, FetchSalesReportDesigner,
    FetchB2COrderState, FetchB2COrderProcessingState,
    FetchBackendPingToPreventTimeout,
    FetchReadServerVersion
    //FetchDummyTest
}